import { render, staticRenderFns } from "./LevelVerticalProgressBar.vue?vue&type=template&id=4a274826&scoped=true&"
import script from "./LevelVerticalProgressBar.vue?vue&type=script&lang=js&"
export * from "./LevelVerticalProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./LevelVerticalProgressBar.vue?vue&type=style&index=0&id=4a274826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a274826",
  null
  
)

export default component.exports